// Calculate gestational age from due date
export function calculateGestationalAge(dueDate) {
  const due = new Date(dueDate);
  const today = new Date();
  const gestationLength = 280; // days in full-term pregnancy

  const daysPregnant = gestationLength - Math.floor((due - today) / (1000 * 60 * 60 * 24));

  const weeks = Math.floor(daysPregnant / 7);
  const days = daysPregnant % 7;

  return { weeks, days, is36Plus: weeks >= 36 };
}
